import { useEffect, useState } from "react";
import "./App.css";
import LeftPanel from "./components/LeftPanel";
import Body from "./components/Body";

const DARK_THEME_ENABLED_KEY = "dark-theme";

function App() {
  const [authenticate, setAuthenticate] = useState(null);
  const [darkThemeEnabled, setDarkThemeEnabled] = useState(
    localStorage.getItem(DARK_THEME_ENABLED_KEY) === "true"
  );
  useEffect(() => {
    localStorage.setItem(
      DARK_THEME_ENABLED_KEY,
      darkThemeEnabled ? "true" : ""
    );
  }, [darkThemeEnabled]);
  console.log("App", authenticate);

  return (
    <div
      className={`app-container my-app${
        darkThemeEnabled ? "-dark" : "-light"
      } disappearing-scrollbars`}
    >
      <LeftPanel
        darkThemeEnabled={darkThemeEnabled}
        setDarkThemeEnabled={setDarkThemeEnabled}
        authenticate={authenticate}
        setAuthenticate={setAuthenticate}
      />
      <div className="app">
        <Body
          authenticate={authenticate}
        />
        {/* <WebRTCFix
          authenticate={authenticate}
        /> */}
        </div>
    </div>
  );
}

export default App;
